// Central content + asset registry for Detour Coffee Co.

export const BUSINESS = {
  name: "Detour Coffee Co.",
  tagline: "Arlington's Favorite Coffee Destination",
  subheadline:
    "Handcrafted coffee, fresh pastries, and Mediterranean-inspired café favorites served all day in the heart of Arlington.",
  address: "946 N Jackson St, Arlington, VA 22201",
  neighborhood: "Virginia Square · Clarendon",
  phone: "(703) 988-2378",
  phoneHref: "tel:+17039882378",
  email: "info@detourcoffeeco.com",
  rating: "4.5",
  orderUrl:
    "https://order.toasttab.com/online/detour-coffee-x-darna-lounge-946-n-jackson-st",
  instagram: "https://www.instagram.com/detourcoffeeco/",
  facebook: "https://www.facebook.com/detourcoffeeco/",
  mapEmbed:
    "https://www.google.com/maps?q=946+N+Jackson+St,+Arlington,+VA+22201&output=embed",
  directions:
    "https://www.google.com/maps/dir/?api=1&destination=946+N+Jackson+St+Arlington+VA+22201",
  giftCardUrl:
    "https://order.toasttab.com/egiftcards/detour-coffee-x-darna-lounge-946-n-jackson-st",
  giftCardBalanceUrl:
    "https://www.toasttab.com/detour-coffee-x-darna-lounge-946-n-jackson-st/findcard",
  marketingSignupUrl:
    "https://www.toasttab.com/detour-coffee-x-darna-lounge-946-n-jackson-st/marketing-signup",  hours: [
    { day: "Monday – Friday", time: "7:30 AM – 10:00 PM" },
    { day: "Saturday", time: "7:30 AM – 10:00 PM" },
    { day: "Sunday", time: "7:30 AM – 10:00 PM" },
  ],
};

const A = "https://customer-assets.emergentagent.com/job_detour-northern-va/artifacts";
const L = "https://customer-assets.emergentagent.com/job_677f1a48-d8fb-448f-996c-0f020d951da3/artifacts";

export const IMG = {
  logo: `${L}/d3nfidg7_Detour-568x227-199w.png`,
  // Authentic Detour photography
  almondCroissant: `${A}/1hlcou65_Screenshot%2B2024-07-01%2Bat%2B3.59.09a%CC%82--PM.png`,
  hazelnutCroissant: `${A}/4apc9rzp_Screenshot%2B2024-07-01%2Bat%2B3.58.54a%CC%82--PM.png`,
  spinachOmelette: `${A}/hn5uhzxn_Screenshot%2B2024-07-01%2Bat%2B3.58.30a%CC%82--PM.webp`,
  breakfastBurrito: `${A}/5yegzlac_Screenshot%2B2024-07-01%2Bat%2B3.56.27a%CC%82--PM.webp`,
  spread: `${A}/1mjpjese_Detour%20coffee.webp`,
  interiorBar: `${A}/codqpf9d_16.jpeg`,
  interiorRoom: `${A}/h5tgvo4k_19.jpeg`,
  eggsBenedict: `${A}/6jqsp0of_b.jpeg`,
  hummus: `${A}/4jck5o46_c.jpeg`,
  kofta: `${A}/gpajuqyj_13.jpeg`,
  cappuccinoReal: `${A}/m5ir9sou_aa.jpeg`,
  sandwichReal: `${A}/z34x610a_g.jpeg`,
  detourWall: `${A}/g24wtln2_v.jpeg`,
  charcuterie: `${A}/7z5xb09g_gg.jpeg`,
  interiorWide: `${A}/6m0172fu_ff.jpeg`,
  // Curated stock — drinks & atmosphere
  lattePour: "https://images.pexels.com/photos/16541078/pexels-photo-16541078.jpeg",
  lattePour2: "https://images.pexels.com/photos/769275/pexels-photo-769275.jpeg",
  cappuccino: "https://images.unsplash.com/photo-1563311977-d285756282dc",
  matcha: "https://images.pexels.com/photos/17366787/pexels-photo-17366787.jpeg",
  coldBrew: "https://images.unsplash.com/photo-1461023058943-07fcbe16d735",
  espresso: "https://images.pexels.com/photos/23915879/pexels-photo-23915879.jpeg",
  salad: "https://images.unsplash.com/photo-1505253716362-afaea1d3d1af",
  croissants: "https://images.unsplash.com/photo-1555507036-ab1f4038808a",
  lifestyle: "https://images.unsplash.com/photo-1598468861060-35ec59804027",
  baristaWork: "https://images.unsplash.com/photo-1665119497578-7750afbc684c",
  cafePeople: "https://images.unsplash.com/photo-1521017432531-fbd92d768814",
  breakfastPlate: "https://images.unsplash.com/photo-1557218392-0119519ce637?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
  pastryCoffee: "https://images.unsplash.com/photo-1780403919362-90a8a0b8527d?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
  sandwichBoard: `${A}/mjdsiuu8_hh.jpeg`,
  coffeeWall: `${A}/svzx2qq0_hhg.jpeg`,
  burger: `${A}/60k1x6jm_dd.jpeg`,
  caprese: `${A}/bpbh93e8_ffg.jpeg`,
  mugChandelier: `${A}/oi5ltgwa_sdff.jpeg`,
};

export const FEATURED_DRINKS = [
  {
    name: "Habibi Latte",
    tag: "Signature",
    notes: "Oat milk, dates, walnuts, cardamom & cinnamon over espresso.",
    img: IMG.cappuccinoReal,
  },
  {
    name: "Detour Delight",
    tag: "Signature",
    notes: "White chocolate-infused pistachio butter, pistachio milk & espresso.",
    img: IMG.lattePour,
  },
  {
    name: "Dubai Chocolate Latte",
    tag: "Indulgent",
    notes: "Espresso, dark chocolate, pistachio cream & steamed milk.",
    img: IMG.espresso,
  },
  {
    name: "Yaffa Matcha",
    tag: "Ceremonial",
    notes: "Japanese green tea, coconut milk & cream, orange blossom.",
    img: IMG.matcha,
  },
  {
    name: "Campfire Latte",
    tag: "Cozy",
    notes: "Mocha, roasted marshmallows & graham crackers.",
    img: IMG.lattePour2,
  },
  {
    name: "Butter Cup Latte",
    tag: "Fan Favorite",
    notes: "Espresso, peanut butter & dark chocolate.",
    img: IMG.cappuccino,
  },
];

export const KITCHEN = [
  {
    name: "Breakfast",
    copy: "Breakfast burrito, avocado toast & the Breakfast Sandwich — served til 5pm.",
    img: IMG.breakfastBurrito,
  },
  {
    name: "Sandwiches",
    copy: "Cold Cuts, the Chicken Sandwich & CBD Smash Burger — all served with house fries.",
    img: IMG.burger,
  },
  {
    name: "Lazy Pitas",
    copy: "Fresh-baked pita stuffed with goodies — Fried Morty, Bepperoni & chicken shawarma.",
    img: IMG.sandwichBoard,
  },
  {
    name: "Detour After 5PM",
    copy: "House hummus, crispy kefta rolls, wings & fattoush — the Mediterranean, shared.",
    img: IMG.hummus,
  },
  {
    name: "Weekend Brunch",
    copy: "Shakshuka, short rib hash, Dubai toast & knafeh pancake — Sat & Sun til 5pm.",
    img: IMG.spread,
  },
];

export const WHY = [
  { icon: "Coffee", title: "Premium Coffee Beans", copy: "Ethically sourced, small-batch roasted for a rich, balanced cup." },
  { icon: "Croissant", title: "Fresh Baked Daily", copy: "Pastries and breads baked in-house before the doors open." },
  { icon: "Salad", title: "Mediterranean Inspired", copy: "A menu rooted in the sun-soaked flavors of the Mediterranean." },
  { icon: "MapPin", title: "Convenient Arlington Location", copy: "Steps from Virginia Square–GMU Metro, with easy street parking." },
  { icon: "Star", title: "Community Favorite", copy: "Rated 4.5 stars by hundreds of Arlington neighbors and regulars." },
];

export const STATS = [
  { value: 4.5, suffix: "★", label: "Average Rating" },
  { value: 480, suffix: "+", label: "Five-Star Reviews" },
  { value: 40, suffix: "+", label: "Menu Creations" },
  { value: 12, suffix: "hrs", label: "Open Every Day" },
];

export const GALLERY = [
  { img: IMG.interiorRoom, label: "The Room", ratio: "4 / 5" },
  { img: IMG.mugChandelier, label: "Mug Chandelier", ratio: "3 / 4" },
  { img: IMG.cappuccinoReal, label: "Latte Art", ratio: "1 / 1" },
  { img: IMG.coffeeWall, label: "The Coffee Wall", ratio: "4 / 5" },
  { img: IMG.burger, label: "House Burger", ratio: "4 / 3" },
  { img: IMG.hummus, label: "House Hummus", ratio: "1 / 1" },
  { img: IMG.spread, label: "The Spread", ratio: "4 / 3" },
  { img: IMG.charcuterie, label: "Mezze & Wine", ratio: "3 / 4" },
  { img: IMG.caprese, label: "Caprese Flatbread", ratio: "1 / 1" },
  { img: IMG.interiorBar, label: "The Bar", ratio: "4 / 3" },
  { img: IMG.kofta, label: "Mediterranean Plates", ratio: "3 / 4" },
  { img: IMG.detourWall, label: "The Detour Wall", ratio: "4 / 5" },
];

export const MENU_NOTES = {
  Breakfast: "Til 5pm",
  Sandwiches: "Til 5pm · Served with house fries",
  Brunch: "Serving Saturday & Sunday · Til 5pm",
  "Cocktails & Wine": "Wine shown Glass / Bottle (single price is by the bottle) · Must be 21+",
};

export const MENU = {
  "Specialty Coffee": [
    { name: "Habibi Latte", desc: "Oat milk, dates, walnuts, cardamom, cinnamon", price: "8 / 9" },
    { name: "Detour Delight Latte", desc: "White chocolate infused pistachio butter, pistachio milk, espresso", price: "10 / 12" },
    { name: "Matcha Colada", desc: "Japanese green tea, pineapple, coconut, banana and coconut cream", price: "8 / 9" },
    { name: "Strawberry Matcha Latte", desc: "Japanese green tea, milk, and natural strawberry puree", price: "6 / 7.50" },
    { name: "Habibi Chai", desc: "Dona masala chai with signature Habibi milk", price: "7 / 8" },
    { name: "London Fog", desc: "Bergamot, vanilla, and steamed milk", price: "6 / 7" },
    { name: "Campfire Latte", desc: "Mocha, roasted marshmallows, and graham crackers", price: "7.50 / 8.50" },
    { name: "Dubai Chocolate Latte", desc: "Espresso, dark chocolate, pistachio cream, and milk", price: "9 / 11" },
    { name: "Oreo Latte", desc: "Espresso and Oreo cream topped with Oreo crumble", price: "7 / 9" },
    { name: "Banana Bread Latte", desc: "Espresso or matcha and homemade banana bread cream", price: "7 / 9" },
  ],
  Breakfast: [
    { name: "Breakfast Burrito", desc: "House-made lamb/beef sausage, egg, cheese, potato, diced veg, tomatillo", price: "13" },
    { name: "Breakfast Sandwich", desc: "Egg patty, cheddar, housemade sausage and bacon, aioli shatta, brioche", price: "14" },
    { name: "Avocado Toast", desc: "Avocado, poached egg, sun dried tomato, herbs, za'atar", price: "13" },
    { name: "Pali Bagel", desc: "Za'atar bagel, labneh, cucumber, tomato, mint, pomegranate", price: "12" },
    { name: "Zaatar Sunrise", desc: "Za'atar bagel, fried egg, haloumi, labneh, arugula, olives", price: "14" },
    { name: "Magician", desc: "Egg, avocado, corn, queso fresco, arepa, Tabasco cream, served with plantains", price: "12" },
    { name: "Old Reliable", desc: "House-made beef bacon, turkey ham, egg and cheese with secret sauce on everything crogel", price: "13" },
    { name: "Yogurt Bowl", desc: "Vanilla greek yogurt, baklava granola, and mixed berry", price: "10" },
  ],
  Sandwiches: [
    { heading: "Cold (on focaccia)" },
    { name: "Cold Cuts", desc: "Salami, mortadella, turkey ham, lettuce, tomatoes, pali pickle relish, shatta vinaigrette dressing, housemade focaccia", price: "16" },
    { name: "Levant Club", desc: "Smoked turkey, stracciatella, tomato, onion, avocado, sprouts and toum on house-made focaccia", price: "14" },
    { name: "Mediterranean Grilled Cheese", desc: "Grilled halloumi, olives, arugula, tomato, za'atar and balsamic on house-made focaccia", price: "13" },
    { name: "B2LT", desc: "Beef, bacon, lettuce, tomatoes, mayo, house-made focaccia (add egg $2 · add turkey $3)", price: "13" },
    { heading: "Hot (on brioche bun)" },
    { name: "U Street", desc: "Fried chicken, cheddar, pickle, lettuce, tomato, onion, brioche, mayo, mumbo sauce", price: "15" },
    { name: "Double Smashed Falafel", desc: "Fresh herbs sauce, pickled onions, yogurt dressing", price: "15" },
    { name: "CBD Burger", desc: "Cheddar, beef bacon, double patty, LTO, secret sauce", price: "16" },
    { name: "Shawarma Ceasar Wrap", desc: "Grilled yogurt marinated chicken, toum, avocado, lettuce, pickles", price: "15" },
  ],
  Salad: [
    { name: "Summer Fattoush Salad", desc: "Romaine, cucumber, cherry tomato, red onion, apple slices, herbs, shatta vinaigrette, pita chips · add grilled chicken breast or steak $7", price: "11" },
  ],
  Sides: [
    { name: "Fries", desc: "Hand cut fries, za'atar spices", price: "7" },
    { name: "Crispy House-Made Sausage Rolls (3)", desc: "Garlic yogurt dipping sauce", price: "9" },
    { name: "Crispy Cheese & Hummus Rolls (3)", desc: "Garlic yogurt dipping sauce", price: "7" },
  ],
  "Detour After 5PM": [
    { name: "Cheddar Bacon Burger Sliders", desc: "House-made beef bacon, grass fed halal beef, brioche sliders with fries", price: "16" },
    { name: "U Street", desc: "Fried chicken, sharp cheddar, mambo sauce, brioche sliders with fries", price: "15" },
    { name: "Wings (6) / Tenders (3)", desc: "Choose wings or boneless tenders, then choose your flavor: zesty yogurt ranch, chili garlic smothered, or sumac honey smothered", price: "9" },
    { name: "Hummus w/ Sausage", desc: "House-made hummus, house-made lamb/beef sausage, fresh pita · available plain 9", price: "11" },
    { name: "Crispy Sausage Rolls (3)", desc: "House-made lamb/beef sausage, garlic yogurt dipping sauce", price: "9" },
    { name: "Crispy Cheese & Hummus Rolls (3)", desc: "Garlic yogurt dipping sauce", price: "7" },
    { name: "Hafla Fries", desc: "Hand cut fries, halloumi & olives, secret sauce", price: "9" },
    { name: "Fries", desc: "Hand cut fries, za'atar spices", price: "7" },
    { name: "Double Smashed Falafel", desc: "Fresh herbs sauce, pickled onions, yogurt dressing", price: "15" },
    { name: "Summer Fattoush Salad", desc: "Romaine, cucumber, cherry tomato, red onion, apple slices, herbs, shatta vinaigrette, pita chips · add grilled chicken breast or steak $7", price: "11" },
    { heading: "Lazy Pitas · Fresh baked pita stuffed with goodies, served with house fries" },
    { name: "Ramallah Bistro", desc: "Grilled steak, pommes frites, garlic toum, arugula, shatta chili crisp", price: "16" },
    { name: "Chicken Shawarma", desc: "Grilled yogurt-marinated chicken, pickles, toum, shatta chili crisp, greens", price: "15" },
    { name: "Bepperoni", desc: "Beef pepperoni, mozzarella cheese, shatta tomato sauce", price: "14" },
    { heading: "Housemade Desserts" },
    { name: "Nutella Kanafa", desc: "Shredded phyllo dough, Nutella s'mores, in a cast iron dish", price: "13" },
    { name: "Kanafa Nabulsi", desc: "Shredded phyllo dough, layered with cheese, in a cast iron dish", price: "13" },
    { name: "Dubai Chocolate Kanafa", desc: "Shredded phyllo dough, pistachio, chocolate, in a cast iron dish", price: "15" },
  ],
  Brunch: [
    { name: "Chicken & Waffle Sandwich", desc: "Housemade fried chicken sausage and bacon, cheddar, mumbo sauce, maple syrup", price: "16" },
    { name: "Brunch Pancake Sandwich", desc: "Egg patty, cheddar, housemade sausage and bacon", price: "15" },
    { name: "Batata & Bayd", desc: "Scrambled eggs & potato. Served with thick sliced house-made beef bacon, house-made lamb/beef sausage link and pita", price: "16" },
    { name: "Short Rib Hash", desc: "3 hour braised short rib, confit potato, sunny up egg, fresh pita bread", price: "16" },
    { name: "Shakshuka", desc: "Egg cooked in zesty tomato sauce, feta cheese, fresh pita bread", price: "14" },
    { name: "Knafeh Pancake", desc: "Buttermilk pancake, sweet cheese, pistachio, honey butter syrup · available plain 11", price: "14" },
    { name: "Banana Baklava French Toast", desc: "Croissant toast, house-made banana cream, baklava, maple syrup", price: "14" },
  ],
  "Housemade Desserts": [
    { name: "Nutella Kanafa", desc: "Shredded phyllo dough, Nutella s'mores, in a cast iron dish", price: "13" },
    { name: "Kanafa Nabulsi", desc: "Shredded phyllo dough, layered with cheese, in a cast iron dish", price: "13" },
    { name: "Dubai Chocolate Kanafa", desc: "Shredded phyllo dough, pistachio, chocolate, in a cast iron dish", price: "15" },
  ],
  "Cocktails & Wine": [
    { heading: "Specialty Cocktails · $11" },
    { name: "Cowboy Coffee", desc: "Jameson, cold brew, fresh coffee beans, lemon", price: "11" },
    { name: "Pistachio Espresso Martini", desc: "Vodka, Kahlua, Bailey's, espresso, house-made pistachio syrup", price: "11" },
    { name: "Matcha Gimlet", desc: "Gin, matcha syrup, sparkling water, lime", price: "11" },
    { name: "Cold Brew Negroni", desc: "Campari, gin, cold brew, orange", price: "11" },
    { name: "Sweet Revenge", desc: "Bourbon, chai, ginger beer, orange juice, cinnamon", price: "11" },
    { heading: "Wine Menu · Red" },
    { name: "Renatopatti Barolo Marcenasco", desc: "2018, Piedmont, Italy", price: "$189" },
    { name: "The Seeker Malbec", desc: "2021, Mendoza, Argentina", price: "$7 / $30" },
    { name: "Seaglass Cabernet", desc: "2023, Central Coast, CA", price: "$7 / $30" },
    { name: "Ironside Cabernet", desc: "2021, Lake County, CA", price: "$46" },
    { name: "Silver Oak Cabernet", desc: "Alexander Valley, CA", price: "$279" },
    { name: "Boen Pinot Noir", desc: "2022, Monterey, Santa Barbara, Sonoma, CA", price: "$59" },
    { name: "Seaglass Pinot Noir", desc: "2023, Central Coast, CA", price: "$7 / $30" },
    { name: "Uspallata Malbec", desc: "2018, Mendoza, Argentina", price: "$195" },
    { heading: "White" },
    { name: "Seaglass Sauvignon Blanc", desc: "2023, Central Coast, CA", price: "$7 / $30" },
    { name: "Seaglass Pinot Grigio", desc: "2023, Central Coast, CA", price: "$7 / $30" },
    { name: "Simi Chardonnay", desc: "Sonoma County, CA", price: "$65" },
    { name: "Elouan Chardonnay", desc: "2022, Oregon", price: "$50" },
    { name: "Freemark Abbey Chardonnay", desc: "2022, Napa Valley, CA", price: "$88" },
    { name: "St Supery Sauvignon Blanc", desc: "2022, Napa Valley, CA", price: "$69" },
    { name: "Hall Sauvignon Blanc", desc: "2023, Napa Valley", price: "$99" },
    { heading: "Sparkling" },
    { name: "Luna Nuda Prosecco", desc: "2022, Veneto, Italy", price: "$7 / $30" },
    { name: "Diora Rose", desc: "2022, Central Coast, CA", price: "$7 / $30" },
  ],
};

export const CATERING = [
  { title: "Office Catering", copy: "Fuel the team with fresh coffee and platters delivered on time." },
  { title: "Corporate Meetings", copy: "Full coffee service and Mediterranean bites for any agenda." },
  { title: "Events", copy: "Showers, launches, celebrations — catered with warmth." },
  { title: "Breakfast Platters", copy: "Croissants, fruit, and house pastries by the dozen." },
  { title: "Coffee Service", copy: "On-site baristas and travelers to keep everyone caffeinated." },
];

export const TESTIMONIALS = [
  {
    quote:
      "Hands down the best coffee in Arlington. The Habibi Latte — dates, cardamom & pistachio — is my daily ritual. I bring my laptop and work from the patio for hours.",
    name: "Maya R.",
    role: "Local Guide · 42 reviews",
  },
  {
    quote:
      "Cozy, welcoming, and the Mediterranean brunch is unreal. Cast-iron shakshuka and a cappuccino on the outdoor patio is my perfect Saturday.",
    name: "Daniel K.",
    role: "Google review · Local since 2019",
  },
  {
    quote:
      "My go-to work-from-café spot near Virginia Square. Fast WiFi, plenty of outlets, friendly baristas, and it's open late. Coffee genuinely worth the detour.",
    name: "Priya S.",
    role: "Remote professional",
  },
  {
    quote:
      "The mug chandelier, the cork wall, the DC art — such a vibe. Fresh pastries every morning and the staff remember your name. Feels like a second home.",
    name: "Jordan T.",
    role: "Google review · 5★",
  },
  {
    quote:
      "Catered our Ballston office and everyone raved. Beautiful platters, seamless coffee service, elegant from start to finish.",
    name: "Alexis M.",
    role: "Office manager, Ballston",
  },
];

// Local-SEO: neighborhoods & areas served near 946 N Jackson St
export const AREAS = [
  "Virginia Square",
  "Clarendon",
  "Ballston",
  "Courthouse",
  "Rosslyn",
  "Lyon Village",
  "Ashton Heights",
  "Cherrydale",
  "Lyon Park",
  "Westover",
  "Ballston–MU",
  "GMU Arlington",
];

export const AMENITIES = [
  { icon: "Wifi", title: "Free High-Speed WiFi", copy: "Strong, fast WiFi throughout — stream, call and upload with ease." },
  { icon: "Laptop", title: "Work-Friendly", copy: "A favorite remote-work spot with roomy tables and a relaxed pace." },
  { icon: "Plug", title: "Plenty of Outlets", copy: "Power up at most seats, indoors and along the patio." },
  { icon: "Sun", title: "Indoor & Outdoor Patio", copy: "Sunny sidewalk patio plus warm, light-filled indoor seating." },
  { icon: "Clock", title: "Open Late — til 10 PM", copy: "Early mornings to late evenings, seven days a week." },
  { icon: "TrainFront", title: "Steps from the Metro", copy: "A short walk from Virginia Square–GMU on the Orange & Silver lines." },
];

export const ORDER_LINKS = [
  {
    name: "Order Direct",
    platform: "Toast",
    tag: "Recommended · no marketplace fees",
    url: "https://order.toasttab.com/online/detour-coffee-x-darna-lounge-946-n-jackson-st",
    recommended: true,
  },
  {
    name: "Uber Eats",
    platform: "Uber Eats",
    tag: "Delivery & pickup",
    url: "https://www.ubereats.com/store/detour-coffee-co/zR5chTrAScq-2bRd_SKWgw?diningMode=PICKUP&utm_campaign=CM2508147-search-free-nonbrand-google-pas_e_all_acq_Global&utm_medium=search-free-nonbrand&utm_source=google-pas&rwg_token=AE37R_iFcSrULMu6WNJhYh8n-jZllEVG-KTU8DqatzPz_9EOtyPhLtqIEHeGj4qJ7eEMsESrsO336dQBLrPgqyxf9pGMuEUdWA%3D%3D",
  },
  {
    name: "DoorDash",
    platform: "DoorDash",
    tag: "Delivery & pickup",
    url: "https://www.doordash.com/store/detour-coffee-x-darna-lounge-946-n-jackson-st-arlington-50955705/116704980/?srsltid=AU7gw4XhWU6xLHPCc4ktmpDvM1ldEyVMEL7Hw4MlQ182h4bPGZbhdbFv",
  },
];


export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Menu", href: "#menu" },
  { label: "Catering", href: "#catering" },
  { label: "Gallery", href: "#gallery" },
  { label: "About", href: "#why" },
  { label: "Contact", href: "#contact" },
];
